import React from 'react';

interface ToggleSelectorProps {
  label?: string;
  options: { value: string; label: string; color?: string }[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
}

export const ToggleSelector: React.FC<ToggleSelectorProps> = ({
  label,
  options,
  value,
  onChange,
  className = "",
  disabled = false
}) => {
  const getOptionStyle = (option: { value: string; label: string; color?: string }) => {
    if (value === option.value) {
      // Selected state
      switch (option.value) {
        case 'Completed':
          return 'bg-green-100 text-green-800';
        case 'Missed':
          return 'bg-red-100 text-red-800';
        default:
          return 'bg-white text-black shadow-sm';
      }
    } else {
      // Unselected state
      return 'text-gray-600 hover:text-gray-800';
    }
  };

  return (
    <div className={className}>
      {label && (
        <span className="text-black font-semibold mb-2 block" style={{ fontSize: '16px', fontWeight: 600 }}>
          {label}
        </span>
      )}
      <div className="flex bg-gray-100 rounded-lg p-1 w-full">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            disabled={disabled}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
              getOptionStyle(option)
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={() => !disabled && onChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}; 